import OFFER from './offer';

export default {
  name: '',
  slug: '',
  tagline: '',
  url: '',
  login_url: '',
  sign_up_url: '',
  permalink: '',
  redirect_url: '',
  sign_up_redirect_url: '',
  login_redirect_url: '',
  casino_stats_regulator: {},
  stats: {
    number_of_plays: 0
  },
  mostPopularGameImage: {
    banner: {
      original: '',
      hero: '',
      hero_sm: ''
    }
  },
  manualMostPopularGames: {
    data: []
  },
  offersCarousel: {
    offer: OFFER,
    slug: '',
    title: ''
  },
  is_favourite: false,
  images: {
    logo: {
      original: '',
      tiny: '',
      small: '',
      medium: '',
      large: ''
    },
    banner: {
      original: '',
      hero: '',
      hero_sm: '',
      optimized: ''
    },
    card: {
      original: '',
      optimized: ''
    },
    building: {
      original: '',
      full: '',
      medium: '',
      small: ''
    },
    ci1: {
      small: '',
      large: ''
    },
    ci2: {
      small: '',
      large: ''
    },
  },
  gameTypes: {
    data: [
      {
        name: '',
        slug: ''
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/models/casino.js